<template>
  <div class="usage-and-invoices">
    <section class="section--usage">
      <h1 class="title is-5">
        Kostenübersicht
        <b-select
          @input="setRange"
          v-model="selectedRange"
          class="is-pulled-right"
          size="is-small"
          type="is-primary"
          placeholder="Zeitraum wählen"
        >
          <option v-for="(range, i) in ranges" :value="i" :key="'r' + i"
            >{{ range.from | formatDate }} bis
            {{ range.to | formatDate }}</option
          >
        </b-select>
      </h1>
      <div class="usage" v-if="!loading && usage.total.gross > 0">
        <div class="usage-types">
          <PieChart
            :data="[
              {
                value: usage.types.C100.gross,
                color: 'hsl(220, 61%, 57%)',
                label: 'C100'
              },
              {
                value: usage.types.C200.gross,
                color: 'hsl(220, 61%, 47%)' /*primary*/,
                label: 'C200'
              },
              {
                value: usage.types.C400.gross,
                color: 'hsl(220, 61%, 37%)',
                label: 'C400'
              },
              {
                value: usage.types.C100P.gross,
                color: 'hsl(100, 61%, 57%)',
                label: 'C100P'
              },
              {
                value: usage.types.C200P.gross,
                color: 'hsl(100, 61%, 47%)' /*primary*/,
                label: 'C200P'
              },
              {
                value: usage.types.C400P.gross,
                color: 'hsl(100, 61%, 37%)',
                label: 'C400P'
              },
              {
                value: usage.types.image.gross,
                color: '#ff3860',
                label: 'Image'
              }
            ]"
          ></PieChart>
        </div>
        <div class="usage-costs">
          <strong class="costs__item costs__item--title">Kosten</strong>
          <span
            class="costs__item"
            v-for="server in usage.servers"
            :key="'s' + server.id"
          >
            <em>{{ server.name }}</em>
            <span class="price">{{ server.usage.gross | pricing }}</span>
          </span>
          <strong class="costs__item costs__item--total"
            >Gesamtkosten<small><sup>1</sup></small>
            <span class="price">{{ usage.total.gross | pricing }}</span></strong
          >
        </div>
      </div>
      <div v-else>
        Keine Kosten vorhanden.
      </div>
      <b-loading :loading="loading"></b-loading>
    </section>
    <hr />
    <section class="section--invoices">
      <h1 class="title is-5">
        Rechnungen
      </h1>
      <p>Keine Rechnung vorhanden.</p>
    </section>
    <hr />
    <p style="font-size:.85em">
      1) Die angegebenen Gesamtkosten sind eine Schätzung nach aktuellem
      Verbrauch, ohne Support-/Setupgebühren. Es gelten die in Rechnung
      gestellten Gebühren.
    </p>
  </div>
</template>

<script>
import PieChart from "../../components/PieChart";
export default {
  name: "DashboardUsage",
  components: { PieChart },
  data() {
    return {
      selectedRange: 0,
      //range: null,
      ranges: [],
      usage: [],
      loading: false,
      autoUpdater: null,
      autoUpdateTimeout: 30000
    };
  },
  computed: {
    range() {
      return this.ranges[this.selectedRange];
    }
  },
  methods: {
    setRange() {
      //const id = event.target.value;
      //this.range = this.ranges[id];
      this.getUsage();
    },
    getUsage() {
      //this.loading = true;
      this.$store.state.api.usages.summary
        .get(this.range.from, this.range.to)
        .then(response => {
          this.usage = response.data;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loading = false;
        });
    },
    getRanges() {
      this.loading = true;
      this.$store.state.api.usages.summary
        .ranges()
        .then(response => {
          this.ranges = response.data;
          this.selectedRange = this.ranges.length - 1;

          this.getUsage();
        })
        .catch(error => console.log(error))
        .finally(() => {
          //this.loading = false;
        });
    }
  },
  created() {
    this.getRanges();
    //this.autoUpdater = setInterval(this.getUsage, this.autoUpdateTimeout);
  },
  beforeDestroy() {
    //clearInterval(this.autoUpdater);
  }
};
</script>

<style scoped lang="scss">
.home {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.usage-and-invoices,
.section--usage {
  width: 100%;
}

.section--usage {
  padding: 0 0 1rem;
}

.usage {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  width: 100%;

  &-types {
    width: 35%;
  }

  &-costs {
    width: 45%;
    display: flex;
    flex-direction: column;

    .costs__item {
      &--title {
        margin-bottom: 0.5rem;
        font-size: 1.1em;
      }

      &--total {
        border-top: 1px solid;
        margin-top: 0.5rem;
        padding-top: 0.25rem;
      }

      .price {
        float: right;
        margin-left: 1rem;
        font-family: monospace;
      }

      & + & {
        margin-top: 0.25rem;
      }
    }
  }
}
</style>
